import React from 'react';
import { observer, inject } from 'mobx-react';

import { Box, Spinner, List, ListItem, Heading } from 'components';
import { SettingsSection } from 'legacyComponents/styled/lib';
import { routerStore } from 'core/routing';

import { GroupsAppManager } from 'apps/group/appManager';
import styled from 'styled-components';
import { SectionTitle } from 'apps/group/styles';

import CollaboratorSettings from 'libs/rendering/components/header/collaboratorsSettings';

import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@chakra-ui/react';
import { Check } from 'icons';
import { Collaborators } from 'apps/initiative/collaborators';

const rolePermissions = {
  owner: [
    'Ultimate control of Content, Memberships and Manufacturing requests and orders.',
  ],
  admin: [
    'Full Access to everything.',
    'Admin Access to all Projects and Files in the Team Workspace',
    'Invite and manage Admins, and Members.',
    'Permissions to submit RFQs and manage Orders.',
    'Full Permissions to Billing Settings, including allocation of seat subscriptions.',
  ],
  member: [
    'Can start Projects, share Files and publish Stories inside a Team Workspace.',
    'Editor Access to all Projects and Files in the Team Workspace',
  ],
  viewer: ['Viewer Access to all Projects and Files in the Team Workspace'],
};

@inject('routerStore')
@observer
export class TeamSettings extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new GroupsAppManager(null, this.props);
  }

  componentDidMount() {
    this.appManager.InitiativeQuery(routerStore.route.params.spacePath);
  }

  render() {
    if (this.appManager.loading) {
      return (
        <SettingsSection>
          <Spinner margin='30px auto' />
        </SettingsSection>
      );
    }

    const { initiativeManager } = this.props;

    const permissionsComponents = [];
    Object.keys(rolePermissions).forEach(key => {
      let displayName = '';
      if (key === 'admin') {
        displayName = 'Team Admins';
      } else if (key === 'owner') {
        displayName = 'Owners';
      } else if (key === 'member') {
        displayName = 'Team Editors';
      } else if (key === 'viewer') {
        displayName = 'Team Viewers';
      }
      const entries = rolePermissions[key];
      permissionsComponents.push(
        <React.Fragment key={key}>
          <StyledPermissionsAccordion allowToggle defaultIndex={[0]}>
            <AccordionItem style={{ border: 'none' }}>
              <AccordionButton
                style={{
                  paddingBottom: '0px',
                  marginBottom: '0px',
                }}
              >
                <SectionTitle level={2} size='small'>
                  {`${displayName} permissions`}
                </SectionTitle>
                <StyledAccordionIcon />
              </AccordionButton>
              <AccordionPanel>
                <List
                  icon={<Check />}
                  style={{
                    paddingVertical: '0px',
                    marginVertical: '0px',
                  }}
                >
                  {entries
                    ? entries.map((row, i) => {
                        return (
                          <ListItem
                            key={i}
                            style={{
                              marginBottom: '0px',
                              marginTop: '0px',
                            }}
                          >
                            {row}
                          </ListItem>
                        );
                      })
                    : null}
                </List>
              </AccordionPanel>
            </AccordionItem>
          </StyledPermissionsAccordion>
          <Box
            style={{
              margin: '1em 0',
              height: '1px',
              backgroundColor: '#d8d8d8',
            }}
          />
        </React.Fragment>,
      );
    });

    return (
      <div className='flex flex-col screen1160:items-center w-4/5'>
        <CollaboratorSettings
          manager={this.appManager}
          borderless={true}
          getRepeatUsers={invitedUsers => {
            return this.appManager.getRepeatInvitationUsers(
              invitedUsers,
              this.appManager.groups.participants,
            );
          }}
          initiativeManager={initiativeManager}
          spaceSlug={routerStore.route.params.spacePath}
        />
        <Collaborators
          loading={this.appManager.loading}
          collaborators={this.appManager.collaborators}
          onRemoveCollaborators={this.appManager.RemoveOutsideCollaborator}
          onRequeryCollaborators={this.appManager.InitiativeQuery}
        />
        <div className='p-4' style={{ width: '38rem' }}>
          <Heading level={2} size='medium' style={{ marginLeft: '1rem' }}>
            Team Permission Description
          </Heading>
          {permissionsComponents}
        </div>
      </div>
    );
  }
}

export const StyledPermissionsAccordion = styled(Accordion)`
  border: none;
  ul {
    padding-left: 0em;
  }
`;

export const StyledAccordionIcon = styled(AccordionIcon)`
  margin-left: 0.5em;
  margin-top: -0.7em;
`;
